import { Heading as HeadingBase, HeadingProps } from '@wix/design-system';
import { st, classes } from './Heading.st.css.js';
import React from 'react';

export function Heading(props: HeadingProps) {
  const { size, className, ...rest } = props;

  return (
    <HeadingBase
      {...rest}
      size={size}
      className={st(classes.root, {
        appearanceH2: size === 'large',
      })}
    />
  );
}
